import { render, staticRenderFns } from "./SendWSMsg.vue?vue&type=template&id=8db73d72&scoped=true&"
import script from "./SendWSMsg.vue?vue&type=script&lang=js&"
export * from "./SendWSMsg.vue?vue&type=script&lang=js&"
import style0 from "./SendWSMsg.vue?vue&type=style&index=0&id=8db73d72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8db73d72",
  null
  
)

export default component.exports